

export class NotificationTypeDto implements INotificationTypeDto {
    id!: number;
    typeName!: string | undefined;
    icon!: string | undefined;
    category!: string | undefined;

    constructor(data?: INotificationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.typeName = _data["typeName"];
            this.icon = _data["icon"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): NotificationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typeName"] = this.typeName;
        data["icon"] = this.icon;
        data["category"] = this.category;
        return data; 
    }
}

export interface INotificationTypeDto {
    id: number;
    typeName: string | undefined;
    icon: string | undefined;
    category: string | undefined;
}

